/**
 * Os textos e o tom de selo que a tela de Residências mostra para cada valor do
 * contrato.
 *
 * Papel: aqui ficam `ROTULOS_CATEGORIA`, `ROTULOS_STATUS`, `TOM_DO_STATUS` e
 * `ROTULO_SEM_RESIDENCIA`, que traduzem o que o banco grava para o que a origem
 * escrevia na tabela e no formulário.
 *
 * Como usar: a ordem do `<select>` de categoria é a de
 * `CATEGORIAS_LANCAMENTO_RESIDENCIA`, e não a das chaves de `ROTULOS_CATEGORIA`.
 * Um valor novo no contrato sem rótulo aqui é recusado pelo typecheck, porque os
 * três mapas são `Record` sobre o tipo do contrato.
 *
 * Compras tem uma constante de mesmo texto que `ROTULO_SEM_RESIDENCIA`, interna
 * a ele; uma não importa a outra, para que mudar o texto de uma tela não mude o
 * da outra.
 */
import {
  type CategoriaLancamentoResidencia,
  type StatusLancamentoResidencia,
} from '@concierge/shared';

/** O texto de cada categoria, como as categorias de Residências na origem. */
export const ROTULOS_CATEGORIA: Record<CategoriaLancamentoResidencia, string> = {
  manutencao_preventiva: 'Manutenção preventiva',
  reparo: 'Reparo',
  taxa_condominial: 'Taxa condominial',
  fornecedor: 'Fornecedor',
  outros: 'Outros',
};

/** O texto de cada situação, no selo da tabela e no `<select>` do formulário. */
export const ROTULOS_STATUS: Record<StatusLancamentoResidencia, string> = {
  pendente: 'Pendente',
  concluido: 'Concluído',
};

/**
 * A variante de `Badge` de cada situação.
 *
 * Só `concluido` é verde, como no `pillClass` da origem, que pinta de âmbar tudo
 * o que não é "Concluído".
 */
export const TOM_DO_STATUS: Record<
  StatusLancamentoResidencia,
  'pendente' | 'concluido' | 'vencido'
> = {
  pendente: 'pendente',
  concluido: 'concluido',
};

/** O título do bloco e o texto da opção do lançamento sem casa. */
export const ROTULO_SEM_RESIDENCIA = 'Ambas / não se aplica';
